module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "live-wrap"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    class: {
      'without-banner': !_vm.footerShow
    }
  }, _vm._l((_vm.list), function(match) {
    return _c('li', {
      key: match.match_id,
      class: {
        top: match.is_top
      },
      on: {
        "click": function($event) {
          _vm.showDialog()
        }
      }
    }, [_c('div', {
      staticClass: "home"
    }, [_c('img', {
      attrs: {
        "src": _vm.getImgSrc(match.team_A_logo),
        "alt": ""
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(match.team_A_name))])]), _vm._v(" "), _c('div', {
      staticClass: "away"
    }, [_c('img', {
      attrs: {
        "src": _vm.getImgSrc(match.team_B_logo),
        "alt": ""
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(match.team_B_name))])]), _vm._v(" "), (match.status !== 'Playing') ? _c('div', {
      staticClass: "status"
    }, [_c('p', {
      staticClass: "competition"
    }, [_vm._v(_vm._s(match.competition_name))]), _vm._v(" "), _c('p', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm.formatData(match.start_play)))])]) : _vm._e(), _vm._v(" "), (match.status === 'Playing') ? _c('div', {
      staticClass: "status"
    }, [_c('p', {
      staticClass: "minute"
    }, [_vm._v(_vm._s(match.minute) + "'")]), _vm._v(" "), _c('p', {
      staticClass: "score"
    }, [_vm._v(_vm._s(match.team_A_score) + " - " + _vm._s(match.team_B_score))]), _vm._v(" "), _c('label', {
      attrs: {
        "for": "score"
      }
    }, [_vm._v("Skor Langsung")])]) : _vm._e()])
  })), _vm._v(" "), (_vm.footerShow) ? _c('footer', {
    on: {
      "click": function($event) {
        _vm.downloadFooter()
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('button', [_vm._v("Dapatkan Gratis")]), _vm._v(" "), _c('span', {
    staticClass: "close-wrap",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.footerShow = false
      }
    }
  }, [_c('img', {
    staticClass: "close",
    attrs: {
      "src": require("../assets/close.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('h2', [_vm._v("All Sepakbola")]), _vm._v(" "), _c('span', [_vm._v("Semua Skor Sepak Bola Terbaru")])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.modalShow) ? _c('div', {
    staticClass: "overlay",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "modal",
    on: {
      "click": function($event) {
        _vm.downloadModal()
      }
    }
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.modalShow = false
      }
    }
  }, [_c('img', {
    staticClass: "close",
    attrs: {
      "src": require("../assets/close.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.alertText)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "download"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('button', [_vm._v("Get it Free")])]), _vm._v(" "), _c('h2', [_vm._v("All Sepakbola")]), _vm._v(" "), _c('span', {
    staticClass: "star"
  }), _vm._v(" "), _c('span', {
    staticClass: "star"
  }), _vm._v(" "), _c('span', {
    staticClass: "star"
  }), _vm._v(" "), _c('span', {
    staticClass: "star"
  }), _vm._v(" "), _c('span', {
    staticClass: "star"
  })])])]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h1', [_vm._v("Tonton Sepak Bola - Live Sepak Bola Gratis")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a44ca1f","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AppLiveList.vue
// module id = 870
// module chunks = 11